import { client } from '@trello/graphql';

import {
  BoardMirrorCardFragmentDoc,
  type BoardMirrorCardFragment,
} from './BoardMirrorCardFragment.generated';

type Card = {
  id: string;
  mirrorSourceId?: string | null;
  dueComplete: boolean;
  closed: boolean;
};

export const getBoardCompletedCardIds = (cards: Card[] = []) => {
  const completedCardIds: string[] = [];
  // this will keep a map of mirror card source ids to the card ids so we can only archive the mirror and not the source
  const mirrorCardMapping: Record<string, string[]> = {};
  cards
    // we need this filter because manually updating the closed field in the cache doesn't mean these cards won't be skipped by the `filter: visible` section in the fragment
    ?.filter((card) => !card.closed)
    .forEach((card) => {
      if (card.mirrorSourceId) {
        // multiple cards could mirror the same source card, so we need to keep track of all of them
        mirrorCardMapping[card.mirrorSourceId] = [
          ...(mirrorCardMapping[card.mirrorSourceId] || []),
          card.id,
        ];
      } else if (card.dueComplete) {
        completedCardIds.push(card.id);
      }
    });

  Object.keys(mirrorCardMapping).forEach((mirrorCardSourceId) => {
    const card = client.readFragment<BoardMirrorCardFragment>({
      fragment: BoardMirrorCardFragmentDoc,
      id: `Card:${mirrorCardSourceId}`,
    });
    if (card?.dueComplete) {
      // if the mirrors source card is marked done, we can archive the mirror card
      completedCardIds.push(...mirrorCardMapping[mirrorCardSourceId]);
    }
  });

  return completedCardIds;
};
